import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mainStore, atHomeStore, reposicaoStore, turmaStore } from '@/store';
import ShowDialog from './ShowDialog.vue';
import { Validator } from 'vee-validate';
import { QrcodeStream } from 'vue-qrcode-reader';
Validator.extend('meetFormat', {
    getMessage: (field) => 'Formato do link Google Meet inválido. Siga o formato: https://meet.google.com/seu-codigo-meet',
    validate: async (v) => !/^https:\/\/meet\.google\.com\/[a-z\-]{8,}$/.test(v),
});
let JaasMeet = class JaasMeet extends Vue {
    constructor() {
        super(...arguments);
        this.aulaOnlineActive = false;
        this.aulas = [];
        this.aulaLink = '';
        this.clicked = false;
        this.turmaAtividadeIdSelecionada = 0;
    }
    get getCurrentUser() {
        return mainStore.userProfile;
    }
    async atualizarLink() {
        if (this.propReposicaoId && this.aulaLink != null) {
            const reposicaoUpdate = {
                id: this.propReposicaoId,
                aula_online_url: this.aulaLink,
            };
            const reposicao_id = await reposicaoStore.updateReposicao(reposicaoUpdate);
        }
        if (this.propProfessorId && this.aulaLink != null) {
            await turmaStore.updateTurmaAtHomeIniciarAula({
                turmaId: this.propTurmaId,
                meetCode: this.extractMeetingCode(this.aulaLink),
            });
        }
        this.handleShowDialog(false);
        this.$forceUpdate();
    }
    extractMeetingCode(meetLink) {
        const regex = /meet\.google\.com\/([^?]*)/;
        const match = meetLink.match(regex);
        return match ? match[1] : null;
    }
    async ativaTurmaDigital() {
        this.clicked = true;
    }
    handleShowDialog(show = true) {
        this.clicked = false;
        const refs = this.$refs.showClass;
        refs.dialog = show;
    }
    async mounted() {
        this.aulaOnlineActive = this.propAulaOnlineActive;
        if (this.propTurmaId) {
            this.aulas = await atHomeStore.getAtHomeTurmaAulaHoje(this.propTurmaId);
        }
        else if (this.propTurmaAlunoId) {
            this.aulas = await atHomeStore.getAtHomeTurmaAlunoAulaHoje(this.propTurmaAlunoId);
            this.aulaLink = Object.values(this.aulas)[0][0].aula_online_url;
        }
        if (this.propReposicaoId) {
            const reposicao = await reposicaoStore.getReposicao(this.propReposicaoId);
            this.aulaLink = reposicao.aula_online_url;
        }
    }
};
__decorate([
    Prop({ type: Number, default: null })
], JaasMeet.prototype, "propReposicaoId", void 0);
__decorate([
    Prop({ type: Number, default: null })
], JaasMeet.prototype, "propTurmaId", void 0);
__decorate([
    Prop({ type: Number, default: null })
], JaasMeet.prototype, "propTurmaAlunoId", void 0);
__decorate([
    Prop({ type: Number, default: null })
], JaasMeet.prototype, "propProfessorId", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], JaasMeet.prototype, "propAulaOnlineActive", void 0);
JaasMeet = __decorate([
    Component({ components: { ShowDialog, QrcodeStream } })
], JaasMeet);
export default JaasMeet;
